<template>
  <v-layout row justify-center>
    <v-dialog v-model="viewReportDialog" persistent max-width="1200">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">add_circle</v-icon>
            View Reports
          </span>
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-tabs
                  v-model="tabs"
                  color="transparent"
                  class="report-tabs"
                >
                  <v-tab href="#tab-info">
                    Info
                  </v-tab>
                  <v-tab href="#tab-report">
                    Ranking
                  </v-tab>

                  <v-tab-item
                    :value="'tab-info'"
                  >
                    <v-card flat>
                      <v-card-text>
                        <template>
                          <table class="tabs-table v-datatable v-table v-datatable--select-all theme--light">
                            <tbody>
                              <tr>
                                  <td>From date: </td>
                                  <td>2019-01-08</td></tr>
                              <tr>
                                  <td>To date: </td>
                                  <td>2019-01-12</td>
                              </tr><tr><td>Url: </td>
                                  <td>www.juul.co.il/</td>
                              </tr>
                              <tr>
                                  <td>Show all dates: </td>
                                  <td>yes</td>
                              </tr>
                            </tbody>
                          </table>
                        </template>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item
                    :value="'tab-report'"
                  >
                    <v-card flat>
                      <v-card-text>
                        <table class="tabs-table v-datatable v-table v-datatable--select-all theme--light">
                          <tbody>
                              <tr>
                                  <th>Keyword</th>
                                  <th>Volume</th>
                                  <th>URL</th>
                                  <th>2019-01-08</th>
                                  <th>2019-01-09</th>
                                  <th>2019-01-10</th>
                                  <th>2019-01-11</th>
                                  <th>2019-01-12</th>
                                  <th>Change</th>
                                  <th>Page</th>
                              </tr>
                              <tr>
                                  <td>Juul</td>
                                  <td></td>
                                  <td>https://www.juul.co.il/</td>
                                  <td></td>
                                  <td></td>
                                  <td>1</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>1</td>
                              </tr>
                              <tr>
                                  <td>apple store israel</td>
                                  <td>880</td>
                                  <td>https://www.juul.co.il/shop/pods</td>
                                  <td>94</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>10</td>
                              </tr>
                              <tr>
                                  <td>apple store ישראל</td>
                                  <td>50</td>
                                  <td>https://www.juul.co.il/shop/pods</td>
                                  <td>91</td>
                                  <td></td>
                                  <td></td>
                                  <td>98</td>
                                  <td></td>
                                  <td>-7</td>
                                  <td>10</td>
                              </tr>
                              <tr>
                                  <td>apple ישראל</td>
                                  <td>210</td>
                                  <td>https://www.juul.co.il/shop/pods/apple-orchard</td>
                                  <td>63</td>
                                  <td></td>
                                  <td></td>
                                  <td>54</td>
                                  <td></td>
                                  <td>9</td>
                                  <td>6</td>
                              </tr>
                              <tr>
                                  <td>hartk</td>
                                  <td>720</td>
                                  <td>https://www.juul.co.il/</td>
                                  <td>31</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>4</td>
                              </tr>
                              <tr>
                                  <td>israel</td>
                                  <td>40500</td>
                                  <td>https://www.juul.co.il/</td>
                                  <td>63</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>7</td>
                              </tr>
                              <tr>
                                  <td>israel online</td>
                                  <td>210</td>
                                  <td>https://www.juul.co.il/shop/devices</td>
                                  <td>31</td>
                                  <td></td>
                                  <td></td>
                                  <td>29</td>
                                  <td></td>
                                  <td>2</td>
                                  <td>3</td>
                              </tr>
                              <tr>
                                  <td>israel plus online</td>
                                  <td>30</td>
                                  <td>https://www.juul.co.il/shop/devices</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>12</td>
                                  <td></td>
                                  <td></td>
                                  <td>2</td>
                              </tr>
                              <tr>
                                  <td>mango ישראל</td>
                                  <td>480</td>
                                  <td>https://www.juul.co.il/shop/pods/mango-nectar</td>
                                  <td></td>
                                  <td></td>
                                  <td>38</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>4</td>
                              </tr>
                              <tr>
                                  <td>mapa israel</td>
                                  <td>590</td>
                                  <td>https://www.juul.co.il/locator</td>
                                  <td>30</td>
                                  <td></td>
                                  <td></td>
                                  <td>52</td>
                                  <td></td>
                                  <td>-22</td>
                                  <td>6</td>
                              </tr>
                              <tr>
                                  <td>use.co.il</td>
                                  <td>480</td>
                                  <td>https://www.juul.co.il/</td>
                                  <td>86</td>
                                  <td></td>
                                  <td></td>
                                  <td>80</td>
                                  <td></td>
                                  <td>6</td>
                                  <td>8</td>
                              </tr>
                              <tr>
                                  <td>zap israel</td>
                                  <td>390</td>
                                  <td>https://www.juul.co.il/</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>23</td>
                                  <td></td>
                                  <td></td>
                                  <td>3</td>
                              </tr>
                              <tr>
                                  <td>שאלות</td>
                                  <td>1900</td>
                                  <td>https://www.juul.co.il/help/faq</td>
                                  <td>28</td>
                                  <td></td>
                                  <td></td>
                                  <td>24</td>
                                  <td></td>
                                  <td>4</td>
                                  <td>3</td>
                              </tr>
                              <tr>
                                  <td>תפוח</td>
                                  <td>3600</td>
                                  <td>https://www.juul.co.il/shop/pods/apple-orchard</td>
                                  <td></td>
                                  <td></td>
                                  <td>90</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>9</td>
                              </tr>
                          </tbody>
                      </table>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>

              </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'ViewReportModal',
  props: ['viewReportDialog', 'loading'],
  data () {
    return {
      tabs: 'tab-info',
      report: {
        name: '',
        domain: '',
        verify_domain: true,
        subdomains: [],
        // keywords: [],
        engine_id: ''
      }
    }
  },
  mounted () {

  },
  computed: {

  },
  methods: {
    closeModal () {
      this.$parent.$emit('viewReportDialog', false)
    }
  }
}
</script>
<style>
.report-tabs >  .v-window {
  border: 1px solid #c6c6c636;
}
</style>



// WEBPACK FOOTER //
// src/components/view-report-modal/ViewReportModal.vue